import { defineComponent as r, ref as a, onMounted as n, createBlock as l, createCommentVNode as d, openBlock as f, Teleport as u, renderSlot as c } from "vue";
const p = /* @__PURE__ */ r({
  name: "RevPortal",
  __name: "Portal",
  props: {
    to: { default: "body" },
    defer: { type: Boolean, default: !1 }
  },
  setup(e) {
    const t = a(!1);
    return n(() => {
      t.value = !0;
    }), (o, m) => t.value ? (f(), l(u, {
      key: 0,
      defer: e.defer,
      to: e.to
    }, [
      c(o.$slots, "default")
    ], 8, ["defer", "to"])) : d("", !0);
  }
});
export {
  p as default
};
